import {Component, Input, OnInit} from '@angular/core';

@Component({
  selector: 'app-section-header',
  templateUrl: './section-header.component.html',
  styleUrls: ['./section-header.component.scss']
})
export class SectionHeaderComponent implements OnInit {
  @Input() header: string;
  @Input() subHeader: string;
  @Input() icon: string;

  constructor() { }

  ngOnInit(): void {
  }

}
